import { GenerateBackgroundByTextMode } from "../models/image-to-image.ts";

export const MAX_ALLOWED_SELECTED_IMAGES = 35;
export const MAX_FILES_LIMIT = 35;
export const MAX_FILE_SIZE = 12 * 1024 * 1024; // 12 MB

export const SOLID_COLOR_CONFIG = {
	selected: false,
	color_code: "#FFFFFF",
};

export const GENERATE_BY_TEXT_CONFIGS = {
	selected: false,
	prompt: "",
	num_results: 4,
	mode: "high_control" as GenerateBackgroundByTextMode,
};

export const GENERATE_BY_IMAGE_CONFIGS = {
	selected: false,
	ref_image_url: "",
	num_results: 4,
};

export const DEFAULT_BACKGROUND_CONFIGS = {
	expand: false,
	remove: false,
	solid: SOLID_COLOR_CONFIG,
	generateByText: GENERATE_BY_TEXT_CONFIGS,
	generateByImage: GENERATE_BY_IMAGE_CONFIGS,
};

export const CUSTOM_SIZE_CONFIGS = {
	selected: false,
	width: 0,
	height: 0,
};

export const DEFAULT_SIZE_CONFIGS = {
	crop: false,
	custom_size: CUSTOM_SIZE_CONFIGS,
};

export enum PollingFileStatus {
	ZERO_BYTE_IMAGE_ERROR = "zero-byte",
	CONTENT_MODERATION = "contentModeration",
	UNAVAILABLE = "unavailable",
	CONTENT_MODERATION_AUTOMOTIVE = "contentModerationAutomotive",
}

export enum ConfigOptions {
	REMOVE = "remove",
	SOLID = "solid",
	EXPAND = "expand",
	BLUR = "blur",
	GENERATE_BY_TEXT = "generateByText",
	GENERATE_BY_IMAGE = "generateByImage",
	CROP = "crop",
	CUSTOM_SIZE = "custom_size",
	MEDIUM_DESTINATION = "medium_destination",
}

export const MAX_THUMBNAIL_IMAGES = 13;

export const ZERO_BYTE_IMAGE_ERROR_MESSAGE = "zero-byte-image-error";
export const CONTENT_MODERATION_INPUT_ERROR = "content-moderation-input-error";
export const engineExpansionError =
	'"Expansion not permitted: one or more selected edges for expansion contain fully transparent pixels in the input image."';
